/**
 * AUTO-GENERATED, DO NOT EDIT DIRECTLY -- run codegen instead.
 * Contains all active Posthog flags.
 */
export enum FeatureFlag {
  UseDecisions = "use-decisions",
  UseZapierIntegration = "use-zapier-integration",
  UseWebhooks = "use-webhooks",
  UseBotIdentities = "use-bot-identities",
  UseVoice = "use-voice",
  UseCommands = "use-commands",
  HasBetaAccess = "has-beta-access",
  RemoveModelSelector = "remove-model-selector",
}
